import { stringify } from 'querystring';
import { camelizeKeys } from 'humps';

import { CommonPublishCoupon, Product } from '@bucketplace/common';

import { clientHttp } from 'common/http';

import { SectionItemsResponse, ResponseGetCouponMoldsPublish, RaffleEventResponse, RaffleEntryResponse, RepresentativeRaffleEvent } from 'promotions/types';

import { fetcher } from 'api/fetcher';

export const publishCartCouponMolds = async (
  { id }: { id: number }
): Promise<ResponseGetCouponMoldsPublish> => {
  const res = await fetcher<ResponseGetCouponMoldsPublish>(`/api/promotions/coupon/${id}`);
  return res;
};

export const publishProductCouponMolds = async (
  { id, userId }: { id: number, userId: string }
): Promise<CommonPublishCoupon> => {
  const json = await clientHttp.post('/api/promotions/product-coupon/create', {
    json: {
      couponMoldId: id,
      userId,
    },
  }).json();
  return camelizeKeys(json) as CommonPublishCoupon;
};

export const getStoreItems = async (
  {
    ids,
    isLoggedIn,
    showCouponBadge,
  }: {
    ids: string[],
    isLoggedIn: boolean,
    showCouponBadge: boolean,
  }
): Promise<Product[]> => {
  try {
    const res = await fetcher<Product[]>(
      `/api/promotions/store-items?${stringify({
        ids: ids.join(','),
        isLoggedIn,
        showCouponBadge,
      })}`
    );

    return res.map((item) => ({
      ...item,
      id: Number(item.id),
    }));
  } catch (error) {
    return [];
  }
};

export const getSectionItems = async (
  id: string,
  detailId: string,
  {
    sectionId,
    page,
    isLoggedIn,
  }: {
    sectionId?: string,
    page: number,
    isLoggedIn: boolean,
  }
): Promise<SectionItemsResponse> => {
  const res = await fetcher<SectionItemsResponse>(
    `/api/promotions/${id}/section-items?${stringify({
      sectionId,
      detailId,
      page,
      isLoggedIn,
    })}`
  );

  return res;
};

export const getExhibitionSectionItems = async (url): Promise<SectionItemsResponse['sectionItems']> => {
  const res = await fetcher<SectionItemsResponse>(url);

  return res.sectionItems;
};

export const getRaffleEvent = async (groupId: string): Promise<RepresentativeRaffleEvent> => {
  const res = await fetcher<RaffleEventResponse>(`/api/promotions/raffle/${groupId}`);

  return res.couponRaffleEvent;
};

export const postRaffleEntry = async (eventId: string, exhibitionId: string): Promise<RaffleEntryResponse> => {
  const res = await clientHttp.post('/api/promotions/raffle/entry', {
    json: {
      eventId: eventId,
      campaignId: exhibitionId,
    },
  }).json();

  return res as RaffleEntryResponse;
};
